import type { QualityReportAiGravimetricComposition } from 'api';
import { Stack } from 'ui';

import { getMaterialsFormatWeightFeature } from '../../utils/materialPercentages/materialPercentages';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';

export const AiAluSampleBreakdown = ({
  composition,
  totalWeight,
}: {
  composition: QualityReportAiGravimetricComposition;
  totalWeight: number;
}) => {
  const { aluminium, ubc, foilAndTray, nonAluminium, foodCans, otherAluminium, otherMetal, nonMetal, total } =
    getMaterialsFormatWeightFeature(composition, totalWeight);

  return (
    <Stack gap={2}>
      <div>
        <MaterialBreakdownItem
          label="Aluminium"
          variant="bold"
          value={aluminium.weight}
          secondaryValue={aluminium.percentage}
        />
        <MaterialBreakdownItem label="UBC" value={ubc.weight} secondaryValue={ubc.percentage} />
        <MaterialBreakdownItem
          label="Foil and Tray"
          value={foilAndTray.weight}
          secondaryValue={foilAndTray.percentage}
        />
        <MaterialBreakdownItem label="Alu Food Can" value={foodCans.weight} secondaryValue={foodCans.percentage} />
        <MaterialBreakdownItem
          label="Other Aluminium"
          value={otherAluminium.weight}
          secondaryValue={otherAluminium.percentage}
        />
      </div>

      <div>
        <MaterialBreakdownItem
          label="Non-Aluminium"
          variant="bold"
          value={nonAluminium.weight}
          secondaryValue={nonAluminium.percentage}
        />
        <MaterialBreakdownItem label="Other Metal" value={otherMetal.weight} secondaryValue={otherMetal.percentage} />
        <MaterialBreakdownItem label="Non Metal" value={nonMetal.weight} secondaryValue={nonMetal.percentage} />
      </div>

      <MaterialBreakdownItem label="Total" value={total.weight} secondaryValue={'100%'} variant="bold" />
    </Stack>
  );
};
